import { FrameLuigiGlobalContext } from '../../models';
import { GithubAuthDataService } from '../github-auth-data.service';
import { GithubTokensService } from '../github-tokens.service';
import { Injectable } from '@angular/core';
import { AnalyticsTrackerConfig } from '@jukebox/common';
import {
  AuthService,
  ClientEnvironment,
  ConfigService,
  EnvConfigService,
  LuigiExtendedGlobalContextConfigService,
  ServiceProvider,
} from '@openmfp/portal-ui-lib';

@Injectable({ providedIn: 'root' })
export class DxpLuigiExtendedGlobalContextConfigService
  implements LuigiExtendedGlobalContextConfigService
{
  constructor(
    private authService: AuthService,
    private configService: ConfigService,
    private envConfigService: EnvConfigService,
    private githubAuthDataService: GithubAuthDataService,
    private githubTokensService: GithubTokensService,
  ) {}

  async createLuigiExtendedGlobalContext(): Promise<FrameLuigiGlobalContext> {
    const portalConfig = await this.configService.getPortalConfig();
    const envConfig =
      (await this.envConfigService.getEnvConfig()) as ClientEnvironment & {
        analyticsTrackerConfig: AnalyticsTrackerConfig;
      };
    await this.githubAuthDataService.readGithubAuthData();
    const tokens = this.githubTokensService.getGithubTokens();
    const userInfo = this.authService.getUserInfo();

    portalConfig.portalContext.extensionManagerMissingMandatoryDataUrl =
      this.getExtensionManagerMissingMandatoryDataUrl(portalConfig.providers);

    return {
      ...tokens,
      tenantid: portalConfig.portalContext.tenantId,
      tenantId: portalConfig.portalContext.tenantId,
      frameContext: portalConfig.portalContext,
      frameBaseUrl: window.location.origin,
      analyticsTrackerConfig: envConfig['analyticsTrackerConfig'],
      alertConfigs: envConfig['alertConfigs'],
      helpContext: undefined,
      token: this.authService.getToken(),
      userid: userInfo.userId,
      useremail: userInfo.email,
    };
  }

  // Jukebox UI needs this URL to show a Page from Extension Manager UI
  private getExtensionManagerMissingMandatoryDataUrl(
    providers: ServiceProvider[],
  ): string | undefined {
    const node = (providers || [])
      .map((provider) => provider.nodes)
      .flat()
      .find((node) => node.context?.providesMissingMandatoryDataUrl);
    return node?.viewUrl;
  }
}
